import React, { useEffect, useState } from "react";


import {
  addToCart,
  openMiniCart,
} from "../../../redux/actions/addToCartAction";
import { useDispatch } from "react-redux";
import { addProductToCart } from "../../../helpers/cartHelpers";
import { useSelector } from "react-redux";
import {setCart} from "../Nosto"

import styles from "../../common/AddToBag/AddToBag.module.scss";

import AddToWishlist from "../AddToWishlist";
import { KlaviyoUserCartDetails } from "../Klaviyo";
import { pushAddToCartEvent, pushCartUpdateEvent } from "@/helpers/cartEventHelper";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { generalConstants } from "@/utils/constants";

export default function GiftAddToBag({
  stickyProductBox,
  finalProductPrice,
  product,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  selectedVariant,
  isSizeSelected,
  isFavourite,
  setIsFavourite,
  setSelectedColor,
  setSelectedLetter,
  setSelectedSize,
  addToBagButtonRef,
  handleAddToBagLoading,
  ...props
}) {
  const cart_list = useSelector((state) => state.click.cart_list);
  let logUser = useSelector((state) => state.loginUser);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [clicked, setOnclick] = useState(false);
  const isSoldOut = isSizeSelected
    ? !selectedVariant?.availableForSale
    : !product?.availableForSale;
  //OS-4874 attribute changes
  const isPWAApp = useSelector((state) => state.pwa.is_PWA);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const availableInCountry = product?.availableInCountry;
  const defaultButtonText = isSoldOut
    ? "Sold out"
    : availableInCountry
    ? "Add to bag"
    : "Add to bag";
  const buttonClass =
    isSoldOut || !availableInCountry ? styles["disabled"] : "";
  const displayHeartIcon =
    (typeof product?.tags !== "undefined" &&
      (product?.tags?.includes("sample") || product?.tags?.includes("gift"))) ||
    isSoldOut
      ? false
      : true;
  const [buttonText, setButtonText] = useState(defaultButtonText);

  const addToBag = async (value) => {
    var addToBag = true;
    if (!isSizeSelected) {
      setIsSizeDropdownOpen(true);
      addToBag = false;
    }
    if (addToBag) {
      setLoading(true);
      //set loading state for add to bag overlay
      handleAddToBagLoading(true)
      let request = {
        variantId: selectedVariant.id,
        quantity: "1",
      };
      if (selectedVariant.barcode) {
        request.lineItemCustomAttributes = [{ key: "_upc", value: selectedVariant.barcode.toString().replace('.00','') }];
      }
      if(selectedVariant.olivela_cost) {
        if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
          request.lineItemCustomAttributes.push({ key: "_oc", value: selectedVariant.olivela_cost.value });
        } else {
          request.lineItemCustomAttributes = [{ key: "_oc", value: selectedVariant.olivela_cost.value }];
        }
      }
      if (product?.vendor) {
        if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
          request.lineItemCustomAttributes.push({ key: "_vendor", value: product.vendor });
        } else {
          request.lineItemCustomAttributes = [{ key: "_vendor", value: product.vendor }];
        }
      }

      //OS-4874 #attribute changes
        //specifying the app or web purchaseS
        request.lineItemCustomAttributes.push({ key: "_device", value: isPWAApp ? "app": isMobile ? "mobile" : "desktop" });

        let availabilityPresent = request.lineItemCustomAttributes.filter((p)=>{
          if(p.key === '_availability'){
              return true;
          }else{
              return false
          }
        })

        if(!availabilityPresent.length) {
          let availabilityType = product?.tags.includes(generalConstants.pre_order_tag) ?  generalConstants.pre_order : product?.tags.includes(generalConstants.available_now_tag) ? generalConstants.available_now : '';
          if(availabilityType) {
            request.lineItemCustomAttributes.push({ key: "_availability", value: availabilityType });
          } else {
            reportError("Checkout now: Product missing availability tag",element?.node?.merchandise?.product?.id);
          }
        }

      let response = await addProductToCart(request);
      
      dispatch(addToCart(response));
      dispatch(openMiniCart(true));
      setButtonText(value);
      setTimeout(() => {
        setButtonText("Add to bag");
      }, 3000);
      setTimeout(() => {
        dispatch(openMiniCart(false));
      }, 5000);
      await setCart(response);
      setLoading(false);
      //set loading state for add to bag overlay
      handleAddToBagLoading(false)
    }
   
  };
   useEffect(() => {
    setButtonText(defaultButtonText);
  }, [defaultButtonText]);
  useEffect(()=>{ 
    if(clicked){
      var data = JSON.parse(localStorage.getItem("pdp_page_view"))

      if(data){
        pushAddToCartEvent(data,selectedVariant,logUser,window.location.href);
        setOnclick(false)
      }
    } 
   
    if(cart_list?.lineItems?.edges?.length){
      pushCartUpdateEvent(cart_list);
    }    
  },[cart_list])
  return (
    <>
      <div className={`${styles["button-group"]}`} role="group">
        <button
          ref={addToBagButtonRef}
          type="button"
          className={`btn-primary small-xs small-sm normal-md btn_loading ${
            isSoldOut ? styles["sold-out"] : styles["add-to-bag-btn-giftCard"]
          } ${loading ? "loading" : ""}`}
          onClick={() => {
            if (!loading) {
              addToBag("Added to Bag");
              setOnclick(true);
            }
          }}
        >
          <span>{props.buttonText || buttonText}</span>
          {!isSoldOut && stickyProductBox && (
            <span className={`${styles["price"]}`}>{finalProductPrice}</span>
          )}
        </button>
      </div>
    </>
  );
}
